import {Component}                          from '@angular/core';
import {VapeDryConfIntf, VapeRecordLogIntf} from '@djsharkk/logr-types';
import {ChartVapeProgressionDayComponent}   from '../../../../../../../logr-charts/visualisations/chart-vape-progression-day/chart-vape-progression-day.component';
import {MenuCrudPanelContentBase}           from '../../menu-crud-panel-content-base';
import {MenuCrudPanelBotComponent}          from '../menu-crud-panel-bot.component';

@Component({
			   selector   : 'app-menu-crud-panel-vape-bot',
			   imports: [
				   MenuCrudPanelBotComponent,
				   ChartVapeProgressionDayComponent
			   ],
			   templateUrl: './menu-crud-panel-vape-bot.component.html',
			   styleUrl   : './menu-crud-panel-vape-bot.component.css'
		   })
export class MenuCrudPanelVapeBotComponent extends MenuCrudPanelContentBase<VapeRecordLogIntf, VapeDryConfIntf> {
	constructor() {
		super('vape', false)

	}


}
